export enum TabKey {
  CUM_PARTICIP = "cum-particip",
  PREMII_ZILNIC = "premii-zilnic",
  MAREA_EXTRAGERE = "marea-finală",
  PREMII_INSTANT = "premii-instant",
}

export type TabType = TabKey;

export interface TabDefinition {
  id: TabKey;
  label: string;
  component: React.ComponentType;
  options?: {
    hideNextDrawContainer?: boolean;
  };
}

export interface DailyPrize {
  prize: string;
  count: string;
  marqueeDescription?: string;
  description?: string;
  imgId: string;
}
